export default "__VITE_ASSET__CnNvbO_x__"